/** Synthetic emails used for phone-only Supabase Auth users (see authStore). */
export function isPlaceholderEmail(email: string | null | undefined): boolean {
  if (!email?.trim()) return true;
  const e = email.trim();
  return e.endsWith('@phone.golfauth.local') || /^phone-[a-f0-9-]+@phone\.golfauth\.local$/i.test(e);
}
